import * as React from "react";
const SvgPricing = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: "32px",
	height: "32px",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props
}, /* @__PURE__ */ React.createElement("title", null, "Icon / Reg / Pricing"), /* @__PURE__ */ React.createElement("desc", null, "Created with Sketch."), /* @__PURE__ */ React.createElement("g", {
	id: "Icon-/-Reg-/-Pricing",
	stroke: "none",
	strokeWidth: 1,
	fill: "none",
	fillRule: "evenodd"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M26,6 L6,6 C4.896,6 4,6.896 4,8 L4,24 C4,25.104 4.896,26 6,26 L26,26 C27.104,26 28,25.104 28,24 L28,8 C28,6.896 27.104,6 26,6 Z M17,20.982 L17,22 C17,22.552 16.552,23 16,23 C15.448,23 15,22.552 15,22 L15,21 L13.5,21 C12.948,21 12.5,20.552 12.5,20 C12.5,19.448 12.948,19 13.5,19 L16.818,19 C17.47,19 18,18.551 18,18 C18,17.449 17.47,17 16.818,17 L15.181,17 C13.427,17 12,15.654 12,14 C12,12.404 13.332,11.108 15,11.018 L15,10 C15,9.448 15.448,9 16,9 C16.552,9 17,9.448 17,10 L17,11 L18,11 C18.552,11 19,11.448 19,12 C19,12.552 18.552,13 18,13 L15.182,13 C14.53,13 14,13.449 14,14 C14,14.551 14.53,15 15.182,15 L16.819,15 C18.573,15 20,16.346 20,18 C20,19.596 18.668,20.892 17,20.982 Z",
	id: "money-card",
	fill: "#333638"
})));
export default SvgPricing;
